class UserEventEmitter {
  private defaultPayload: { [key: string]: any } = {}

  private subscribers: Function[] = []

  subscribe(handler: Function) {
    this.subscribers.push(handler)

    return () => {
      const index = this.subscribers.indexOf(handler)
      this.subscribers.splice(index, 1)
    }
  }

  setDefaultPayload(payload: { [key: string]: any }) {
    this.defaultPayload = payload
  }

  emit(eventName: string, eventPayload: { [key: string]: any }) {
    const listeners = this.subscribers
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < listeners.length; i++) {
      const listener = listeners[i]
      try {
        listener(eventName, {
          ...this.defaultPayload,
          ...eventPayload,
        })
      } catch (e) {
        console.error('Error on emitting event')
        console.error(e)
      }
    }
  }
}

export default UserEventEmitter
